import { Col, Row, Form } from "react-bootstrap"; // Added Form for input
import { useState, useEffect, useMemo } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Title from "../Viewfriends/Conponents/Title/Title";
import { FriendsProfiles } from "../../../../../constants/jsonConstant";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAsset } from "../../../../../helpers/helper";
import dummyUser from "../../../../../assets/images/dummy/dummy-user.png";
import { FailedNotify, SuccessNotify } from "../../../../../constants/tostify";
import {
  useSendConnectionRequestMutation,
  useDisconnectMutation,
  useGetAllConnectedQuery,
  useGetRandomSuggestionsQuery,
} from "../../../../../features/connection/connectionApiSlice";
import Subscriptionmdl from "../../../../../components/subscription_modal/index";
import { encodeId } from "../../../../../utils/idObfuscator";
import "./viewbusiness.css";

const businessTypeRoutes = {
  homemadeShop: "/Home-Made-Item-Userprofile/",
  gemShop: "/Minerl-And-Mining-UserProfile/",
  services: "/services-online/",
  usedShop: "/usedItems-userprofile/",
  rawmaterialShop: "/rawmaterial-userprofile/",
  manufacturerShop: "/manufacturer-userprofile/",
  wholesellerShop: "/wholeseller-userprofile/",
  retailerShop: "/retailer-userprofile/",
  recycledShop: "/Recycleuserprofile/",
  farmingShop: "/Farminguserprofile/",
  usedVehicleShop: "/Byvehicleuserprofile/",
  transportShop: "/buying-transport/",
  businessPropertyCompany: "/user-peronal-property/",
  foodShop: "/food-buying-profile/",
  company: "/find-jobs-online/",
  jobsCompany: "/find-jobs-online/",
  generalPublic: "/other-profile/",
  marketerProfile: "/view-marketer-profile/",
  "Approved Marketers": "/view-marketer-profile/",
};

const Viewbusinessfriend = ({ id, setProfileshowhide, profileurl, mybusinessType, viewBusinessType }) => {
  const [key, setKey] = useState("home");
  const [searchText, setSearchText] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const { name } = useSelector((state) => state.user);
  const [sendingConnect, setSendingConnect] = useState({});

  // Subscription modal state
  const [lgShow, setLgShow] = useState(false);
  const [purchase, setPurchase] = useState(false);

  const { data: allConnectedData } = useGetAllConnectedQuery(
    { shopid: id, userid: name?._id },
    { skip: !id || !name?._id },
  );

  const selectedBT = viewBusinessType || location.state?.ViewConnectedProfiles;

  const connectedData = useMemo(() => {
    const connectedBT =
      allConnectedData?.connectedBT ||
      allConnectedData?.data?.connectedBT ||
      [];
    const matched = connectedBT.find((bt) => bt.businessType === selectedBT);
    return matched || null;
  }, [allConnectedData, selectedBT]);

  const { data: randomSuggestionsData } = useGetRandomSuggestionsQuery(
    {
      userid: name?._id,
      businessType: mybusinessType,
      shopid: id,
      FindBT: connectedData?.businessType,
    },
    { skip: !connectedData?.businessType || !name?._id || !id },
  );

  const randomProfiles = useMemo(() => {
    return randomSuggestionsData?.data || randomSuggestionsData || [];
  }, [randomSuggestionsData]);

  const [disconnectConnection] = useDisconnectMutation();
  const [sendConnectionRequest] = useSendConnectionRequestMutation();

  /* ================= REMOVE CONNECTION ================= */
  const handleRemove = async (item) => {
    try {
      const effectiveBT = connectedData?.businessType || item?.businessType;
      const isGP = effectiveBT === "generalPublic";

      const payload = {
        senderid: name?._id,
        senderBusinessType: mybusinessType,
        sendershopid: isGP ? undefined : id,
        businessType: effectiveBT,
        recieverid: item?.userid,
        recievershopid: isGP ? undefined : item?.shopid,
      };

      await disconnectConnection(payload).unwrap();
      SuccessNotify("Connection removed successfully");
    } catch (error) {
      FailedNotify("Connection request not found in sender's connected list");
    }
  };

  /* ================= SEND CONNECT REQUEST ================= */
  const handleConnect = async (e) => {
    try {
      const key = e.userid || e.shopid;
      setSendingConnect((prev) => ({ ...prev, [key]: true }));

      // Determine the effective businessType for this connection
      const effectiveBT = e?.businessType || connectedData?.businessType || selectedBT;
      const isGP = effectiveBT === "generalPublic";

      const payload = {
        senderid: name?._id,
        senderBusinessType:
          mybusinessType === "marketerProfile"
            ? "marketerProfile"
            : mybusinessType || "generalPublic",
        // Do NOT send sendershopid for generalPublic connections —
        // the server uses it to apply same-zone filtering, which must
        // not apply to generalPublic connections.
        sendershopid:
          isGP || mybusinessType === "marketerProfile" ? undefined : id,
        businessType: effectiveBT,
        recieverid: e?.userid,
        recievershopid: isGP ? undefined : e?.shopid,
        // Zone filtering ignores this, but it keeps the connection tied to the
        // shop it was sent from so it appears on that shop's Connectivity.
        senderShopContextId:
          isGP && mybusinessType !== "marketerProfile" ? id : undefined,
        ...(mybusinessType === "marketerProfile"
          ? { asMarketerProfile: true }
          : {}),
      };

      await sendConnectionRequest(payload).unwrap();

      SuccessNotify("Connect request sent successfully!");
      setSendingConnect((prev) => ({ ...prev, [key]: false }));
    } catch (error) {
      console.error("Send connect request failed:", error);
      const backendMessage = error?.data?.message || error?.message || "";
      if (backendMessage.toLowerCase().includes("limit exceeded")) {
        FailedNotify(backendMessage);
        setLgShow(true);
      } else {
        FailedNotify(backendMessage || "Something went wrong while sending request");
      }
      const key = e.userid || e.shopid;
      setSendingConnect((prev) => ({ ...prev, [key]: false }));
    }
  };

  /* ================= FILTERED DATA ================= */
  const filteredConnected =
    connectedData?.items?.filter((item) =>
      (item?.shopname || "").toLowerCase().includes(searchText.toLowerCase()),
    ) || [];

  const filteredRandom = (
    randomProfiles.length ? randomProfiles : FriendsProfiles
  ).filter((item) =>
    (item?.shopname || item?.name || "")
      .toLowerCase()
      .includes(searchText.toLowerCase()),
  );
  return (
    <div className="connectivity-view border ps-0 pe-0 height_100">
      <Subscriptionmdl
        lgShow={lgShow}
        setLgShow={setLgShow}
        setPurchase={setPurchase}
        purchase={purchase}
      />
      {/* ================= BACK BUTTON ================= */}
      <div onClick={() => setProfileshowhide(false)}>
        <KeyboardBackspaceIcon
          fontSize="large"
          className="m-2"
          style={{ cursor: "pointer" }}
        />
      </div>

      <Row className="connectivity-view-tabs-row">
        <Col xs={12}>
          <Tabs
            activeKey={key}
            onSelect={(k) => setKey(k)}
            className="connectivity-view-tabs mb-3 display-setting font_sm d-flex justify-content-center"
          >
            {/* ================= MY FRIENDS ================= */}
            <Tab eventKey="home" title="My Friend's">
              <Title
                searchText={searchText}
                setSearchText={setSearchText}
                name={
                  connectedData?.businessType === "generalPublic"
                    ? "General Public Profile"
                    : connectedData?.businessType === "businessPropertyCompany"
                    ? "Business Property"
                    : connectedData?.businessType
                    ? connectedData.businessType.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())
                    : ""
                }
                title={`${connectedData?.count || 0} ${
                  connectedData?.businessType === "generalPublic"
                    ? "General Public Profile"
                    : connectedData?.businessType === "businessPropertyCompany"
                    ? "Business Property"
                    : connectedData?.businessType
                    ? connectedData.businessType.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())
                    : ""
                }`}
              />

              <div className="noscroll request_height connectivity-profile-list">
                <Row className="connectivity-profile-grid ps-4 pe-4">
                  {filteredConnected.map((item) => (
                    <Col
                      key={item?._id}
                      lg="2"
                      md="4"
                      sm="6"
                      xs="6"
                      className="connectivity-profile-column border mt-3 p-2"
                    >
                      <div className="connectivity-profile-card-content d-flex align-items-center flex-column">
                          <img
                            src={(() => {
                              const imgSource = item?.image || item?.imageUrl;
                              if (!imgSource || imgSource === "N/A" || imgSource.length === 0) return dummyUser;
                              const finalSrc = Array.isArray(imgSource) ? imgSource[0] : imgSource;
                              return finalSrc ? getAsset(finalSrc) : dummyUser;
                            })()}
                            alt={item?.shopname || "profile"}
                            className="profile_img"
                            crossOrigin="anonymous"
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = dummyUser;
                            }}
                          />

                        <h6 className="font-sm">
                          {item?.shopname ||
                            item?.fullname ||
                            item?.companyname}
                        </h6>

                        <div
                          className="font_11 mob_f font-grey"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const routeBT =
                              item?.shopid && item?.linkBusinessType
                                ? item.linkBusinessType
                                : connectedData?.businessType;
                            const bt =
                              routeBT || connectedData?.businessType;
                            const userIdForProfile =
                              item?.userid?._id ||
                              item?.userid ||
                              (!item?.shopid ? item?._id : null) ||
                              null;

                            const hasShop = Boolean(
                              (item?.shopid && item?.shopid !== "null") ||
                              (routeBT && routeBT !== "generalPublic" && businessTypeRoutes[routeBT]) ||
                              (item?.businessType && item?.businessType !== "generalPublic" && businessTypeRoutes[item.businessType])
                            );

                            if (
                              !hasShop &&
                              (bt === "generalPublic" ||
                                connectedData?.businessType ===
                                  "generalPublic") &&
                              userIdForProfile
                            ) {
                              navigate(
                                `/other-profile/${encodeId(String(userIdForProfile))}`,
                              );
                              return;
                            }

                            const route =
                              businessTypeRoutes[bt] ||
                              businessTypeRoutes[connectedData?.businessType];
                            const viewId =
                              item?.shopid?._id ||
                              item?.shopid ||
                              item?.userid?._id ||
                              item?.userid ||
                              item?._id;
                            if (route && viewId) {
                              const finalId =
                                routeBT === "marketerProfile" ||
                                routeBT === "Approved Marketers"
                                  ? encodeId(viewId)
                                  : viewId;
                              navigate(`${route}${finalId}`);
                            }
                          }}
                        >
                          <VisibilityIcon style={{ fontSize: "14px" }} />
                          View Shop
                        </div>

                        <button
                          type="button"
                          className="folow-btn mt-1"
                          onClick={() => handleRemove(item)}
                        >
                          Remove
                        </button>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Tab>

            {/* ================= RANDOM PEOPLE ================= */}
            <Tab eventKey="profile" title="Random Poeple's">
              <Title
                searchText={searchText}
                setSearchText={setSearchText}
                name="Random Friend's"
                title={`${filteredRandom?.length || 0}`}
              />

              <div className="noscroll request_height connectivity-profile-list">
                <Row className="connectivity-profile-grid ps-4 pe-4">
                  {filteredRandom.map((e, index) => (
                    <Col
                      key={index}
                      lg="2"
                      md="4"
                      sm="6"
                      xs="6"
                      className="connectivity-profile-column border mt-3 p-2"
                    >
                      <div className="connectivity-profile-card-content d-flex align-items-center flex-column">
                        <img
                          src={
                            e?.image?.[0] || e?.imageUrl?.[0]
                              ? getAsset(e?.image?.[0] || e?.imageUrl?.[0])
                              : dummyUser
                          }
                          alt={e?.shopname || e?.fullname || "profile"}
                          className="profile_img"
                          crossOrigin="anonymous"
                          onError={(ev) => {
                            ev.target.onerror = null;
                            ev.target.src = dummyUser;
                          }}
                        />

                        <h6 className="font-sm">
                          {e?.shopname || e?.fullname || e?.companyname}
                        </h6>

                        <div
                          className="font_11 mob_f font-grey"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const bt = e?.businessType;
                            const userIdForProfile =
                              e?.userid?._id ||
                              e?.userid ||
                              (!e?.shopid ? e?._id : null) ||
                              null;

                            const hasShop = Boolean(
                              (e?.shopid && e?.shopid !== "null") ||
                              (bt && bt !== "generalPublic" && businessTypeRoutes[bt])
                            );

                            if (
                              !hasShop &&
                              (bt === "generalPublic" ||
                                connectedData?.businessType ===
                                  "generalPublic") &&
                              userIdForProfile
                            ) {
                              navigate(
                                `/other-profile/${encodeId(String(userIdForProfile))}`,
                              );
                              return;
                            }

                            const route = businessTypeRoutes[bt];
                            const viewId =
                              e?.shopid?._id ||
                              e?.shopid ||
                              e?.userid?._id ||
                              e?.userid ||
                              e?._id;
                            if (route && viewId) {
                              const finalId =
                                e?.businessType === "marketerProfile" ||
                                e?.businessType === "Approved Marketers"
                                  ? encodeId(viewId)
                                  : viewId;
                              navigate(`${route}${finalId}`);
                            }
                          }}
                        >
                          <VisibilityIcon style={{ fontSize: "14px" }} />
                          View Shop
                        </div>

                        <button
                          type="button"
                          className="folow-btn mt-1"
                          onClick={() => handleConnect(e)}
                          disabled={sendingConnect[e.userid || e.shopid]}
                        >
                          {sendingConnect[e.userid || e.shopid]
                            ? "Sending..."
                            : "Connect"}
                        </button>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </div>
  );
};

export default Viewbusinessfriend;
